module.exports = __webpack_public_path__ + "img/yhgh.f7290151.png";